import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Settings } from "lucide-react";
import { Logo } from "./Logo";
import { scrollToId, getToken } from "../lib/api";

const LINKS = [
    { label: "Causes", hash: "#causes" },
    { label: "Solutions", hash: "#solutions" },
    { label: "Products", hash: "#products" },
    { label: "Analysers", hash: "#analyzers" },
    { label: "FAQ", hash: "#faq" },
];

export const Header = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const goToSection = (hash) => {
        if (location.pathname !== "/") {
            navigate("/");
            setTimeout(() => scrollToId(hash), 900);
        } else {
            scrollToId(hash);
        }
    };

    const goTop = (e) => {
        e.preventDefault();
        if (location.pathname !== "/") {
            navigate("/");
        } else if (window.__lenis) {
            window.__lenis.scrollTo(0);
        } else {
            window.scrollTo({ top: 0, behavior: "smooth" });
        }
    };

    return (
        <header className="sticky top-0 z-50 border-b border-[#E4DFD3] bg-[#FDFCF8]/80 backdrop-blur-xl">
            <div className="max-w-[760px] mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
                <a href="/" data-testid="header-logo" onClick={goTop} className="transition-opacity hover:opacity-80">
                    <Logo />
                </a>
                <nav className="hidden md:flex items-center gap-6">
                    {LINKS.map((l) => (
                        <button
                            key={l.hash}
                            data-testid={`nav-link-${l.label.toLowerCase()}`}
                            onClick={() => goToSection(l.hash)}
                            className="text-sm font-medium text-[#6D736D] hover:text-[#1A1D1A] transition-colors"
                        >
                            {l.label}
                        </button>
                    ))}
                    <Link
                        to="/tools"
                        data-testid="nav-link-tools"
                        className="text-sm font-medium text-[#6D736D] hover:text-[#1A1D1A] transition-colors"
                    >
                        Tools
                    </Link>
                </nav>
                <Link
                    to={getToken() ? "/settings" : "/login"}
                    data-testid="nav-settings-btn"
                    className="inline-flex items-center gap-1.5 rounded-full border border-[#E4DFD3] bg-white/60 px-3.5 py-1.5 text-xs font-semibold text-[#576856] hover:border-[#C4BCA8] hover:bg-white transition-colors"
                >
                    <Settings size={13} strokeWidth={1.8} />
                    Owner
                </Link>
            </div>
        </header>
    );
};
